import { observer } from 'mobx-react-lite'
import React from 'react'
import { Alert, Typography } from 'shared/ui'
import styles from './styles.module.scss'

interface IFeatureRestrictedModalContentProps {
  desc: string
}

export const FeatureRestrictedModalContent = observer(
  ({ desc }: IFeatureRestrictedModalContentProps) => {
    return (
      <div className={styles.content}>
        <Typography
          variant={'heading-md'}
          marginBottom={32}
          color={'var(--content-primary-primary)'}
          ariaLabel={'This feature is restricted'}
        >
          This feature is restricted
        </Typography>
        <Alert
          className={styles.alert}
          item={{
            type: 'infoBlue',
            title: 'Ask one of your admins to give you this permission:',
            desc,
          }}
        />
      </div>
    )
  }
)
